import { Button } from '@mui/material'
import Web3 from 'web3'
import { useTranslation } from 'react-i18next'

import { MetamaskIcon } from 'src/assets/icons'
import { AppEvents } from 'src/constants'
import { HelperWrapper } from '../helper-wrapper'

export const BaseNetworkButton = () => {
  const [t] = useTranslation()
  const handleAddBaseNetwork = async () => {
    if (window.ethereum) {
      const web3 = new Web3(window.ethereum)

      try {
        await window.ethereum.request({
          method: 'wallet_addEthereumChain',
          params: [
            {
              chainId: '0x2105',
              chainName: 'Base Mainnet',
              nativeCurrency: {
                name: 'ETH',
                symbol: 'ETH',
                decimals: 18,
              },
              rpcUrls: ['https://mainnet.base.org'],
              blockExplorerUrls: ['https://basescan.org'],
            },
          ],
        })

        const networkId = await web3.eth.net.getId()
        if (Number(networkId) === 8453) {
          return dispatchEvent(AppEvents.HTTP_SUCCESS, t('network-add-button-notification.v'))
        }
        throw new Error()
      } catch (error) {
        dispatchEvent(AppEvents.HTTP_ERROR, t('network-add-button-notification-error.v'))
      }
    } else {
      dispatchEvent(AppEvents.HTTP_ERROR, t('network-add-button-metamask-notification-error.v'))
    }

    function dispatchEvent(type: AppEvents, message: string) {
      const detail = { message }
      const event = new CustomEvent(type, { detail })
      document.dispatchEvent(event)
    }
  }

  return (
    <Button
      size="small"
      startIcon={<MetamaskIcon />}
      variant="outlined"
      onClick={handleAddBaseNetwork}
    >
      <HelperWrapper t="base-add-button-text" />
    </Button>
  )
}
